var render = function render(){var _vm=this,_c=_vm._self._c;return _c(require(`../../assets/icons/${_vm.name}.svg`).default,{tag:"component",staticClass:"icon",class:{ 'rtl-flip': _vm.rtlFlip },attrs:{"viewBox":_vm.viewBox,"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }